/**
 * 购物车
 */
class CartItems extends HTMLElement {
    constructor() {
      super();
      
      this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]')).reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);
      this.debouncedOnChange = debounce((event) => {
        this.onChange(event);
      }, 300);
      this.addEventListener('change', this.debouncedOnChange.bind(this));
      this.accessoryRecommendationAdd()
      this.resetPerfectScrollbar();
      this.cartOffcanvas = document.querySelector("header-cart-dropdown");
      this.updateIntegralFunc()
      updateIntegral({domId: 'integral-cart'})
  }
  async updateIntegralFunc() {
    let e =  await this.getCartData();
    updateIntegral({
      domId: 'integral-cart',
      productList: e.items
    })
  }
  /**
   * 绑定数量增减时的函数
   * @param event
   */
  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }
  
  /**
   * 获取动态数据
   * @returns {[{section: string, selector: string, id: string}, {section: string, selector: string, id: string}]}
   */
  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-badge',
        selector: '#cart-icon-bubble'
      }
    ];
  }
  
  /**
   * 更新购物车数量
   * @param line
   * @param quantity
   * @param name
   */
  updateQuantity(line, quantity, name) {
    this.enableLoading(line);
    
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cartChangeUrl}`, {...fetchConfig(), ...{body}})
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.renderContents(parsedState);
        this.updateLiveRegions(line, parsedState.item_count);
        this.disableLoading();
        updateIntegral({
          domId: 'integral-cart',
          productList: parsedState.items
        })
      }).catch((err) => {
      console.error(err);
      document.querySelector('cart-error-message.uk-alert').show();
      document.querySelector('cart-error-message.uk-alert').setContent(window.cartStrings.error);
      this.disableLoading();
    });
  }
  
  /**
   * 更新DOM
   */
  renderContents(state) {
    this.getSectionsToRender().forEach((section => {
      const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
      elementToReplace.innerHTML = this.getSectionInnerHTML(state.sections[section.section], section.selector);
    }));
    // 更新购物车后再声明一次事件
    this.accessoryRecommendationAdd();
    this.resetPerfectScrollbar();
  }
  
  // 更新数量报错信息
  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const lineItem = document.getElementById(`Line-item-error-${line}`);
      if (!lineItem) {
        return;
      }
      lineItem.show();
      lineItem.setContent(window.cartStrings.quantityError.replace('[quantity]', document.getElementById(`Quantity-${line}`).value))
    }
    this.currentItemCount = itemCount;
  }
  
  /**
   * 获取数据
   * @param html
   * @param selector
   * @returns {*}
   */
  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }
  
  enableLoading(line) {
    this.querySelectorAll('loading-animation')[line - 1].show();
    document.activeElement.blur();
  }
  
  disableLoading() {
    this.querySelectorAll('loading-animation').forEach((overlay) => overlay.hide());
  }

  async getCartData () {
    var t = JSON.stringify({
      sections: this.cartOffcanvas.getSectionsToRender().map(t => t.section),
      sections_url: window.location.pathname
    });
    return fetch("" + routes.cart_update_url, {
      ...fetchConfig(),
      body: t
    }).then(t => t.text()).then(t => JSON.parse(t))
  }


  accessoryRecommendationAdd () {
    var allBtn = this.querySelectorAll(".cart-accessory-recommendation-btn");
    var cartRecommendBoxLoading = document.querySelector(".cart-recommend-box-loading");
    allBtn.forEach(btn => {
      btn.addEventListener('click', (event) => {
        cartRecommendBoxLoading.show()

        // 获取变体 ID
        var variantId = btn.getAttribute("data-id");
        // console.log('variantId', variantId);
        // 创建一个加入购物车的请求
        var addToCartRequest = {
          items: [
            {
              id: variantId,
              quantity: 1
            }
          ]
        };
        // 发送请求并将产品添加到购物车
        fetch(routes.cart_add_url + ".js", {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(addToCartRequest)
        }).then(t => t.json()).then(async t => {
          let e = await this.getCartData();
          this.cartOffcanvas.renderContents(e);
          updateIntegral({
            domId: 'integral-cart',
            productList: e.items
          })
        }
        ).catch(t => {
          console.log('t', t);
          UIkit.offcanvas(this.cartOffcanvas).hide()
        }
        ).finally(() => {
          cartRecommendBoxLoading.hide()
        }
        )
      }, false)
    })
  }

  // 滚动条
  resetPerfectScrollbar() {
    if(document.querySelector(".cart-recommend-box-content")){
      const ps = new PerfectScrollbar('.cart-recommend-box-content', {
        wheelSpeed: 2,
        wheelPropagation: true,
        minScrollbarLength: 20
      });
  
      ps.update();
    }
  }
}

customElements.define('cart-items', CartItems);

class HeaderCartDropdown extends CartItems {
  constructor() {
    super();
  }
  
  getSectionsToRender() {
    return [
      {
        id: 'cart-offcanvas-nav',
        section: 'header-cart-dropdown',
        selector: '[data-cart-content]'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-badge',
        selector: '#cart-icon-bubble'
      }
    ];
  }
}

customElements.define('header-cart-dropdown', HeaderCartDropdown);

